.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-3);
  min-width: 18rem;
  max-width: 22rem;
  border: 1px solid var(--tuna-color-border);
  border-radius: var(--tuna-radius-sm);
  background: var(--tuna-color-surface);
}

.title {
  font-size: var(--tuna-fontsize-md);
  font-weight: 600;
  margin: 0;
}

.hint,
.empty {
  font-size: var(--tuna-fontsize-sm);
  color: var(--tuna-color-text-secondary);
  margin: 0;
}

.list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.listItem {
  margin: 0;
}

@media (max-width: 959px) {
  .panel {
    max-width: 100%;
    width: 100%;
  }
}
